<template>
  <div :title="`${action_name} ${module_name}`" button-accept="false" button-cancel="false" :active.sync="isActive">
    <div class="mb-4 flex items-center">
      <vs-button @click="isActive = false" color="dark" type="filled" icon-pack="feather" icon="icon-arrow-left"> Back </vs-button>
    </div>
    <form method="POST" @submit.prevent="save_changes">
      <!-- Gurudwara Name -->
      <div class="mb-3">
        <vs-input
          icon-pack="feather"
          class="w-full"
          v-validate="'required|exclude_special_char'"
          v-model="form.label"
          label="FAQ Title *"
          placeholder="Contact Details"
          name="FAQ Title"
          id="FAQ Title"
          :disabled="!isEditable"
        />
        <span class="text-danger text-sm" v-show="errors.has('FAQ Title')">{{ errors.first('FAQ Title') }}</span>
      </div>

      <div>
        <!-- faq Section -->
        <div class="w-full">
          <vs-divider></vs-divider>
          <div class="flex justify-between">
            <div class="flex items-center text-center">
              <h3 class="text-xl mb-4 mt-5">Fill FAQ Details</h3>
            </div>
            <!-- <vs-button @click="addData('faq')" class="mb-4 color" size="default"> Add FAQ</vs-button> -->
          </div>
          <vs-divider></vs-divider>

          <div class="faq-container">
            <div v-for="(faqValue, index) in form.details" :key="index" class="sarai-entry flex flex-wrap justify-between border-sky-500 border">
              <!-- Container for the fields in a single row -->
              <div class="w-full flex items-center justify-between m-0">
                <div class="w-full">
                  <div class="px-2 mb-4">
                    <vs-input
                      icon-pack="feather"
                      type="text"
                      v-validate="'required|exclude_special_char'"
                      data-vv-as="FAQ Heading"
                      v-model="faqValue.question"
                      label="FAQ Heading *"
                      min="1"
                      placeholder="What is the Whatsapp number for Khalsa Aid?"
                      :name="'faq_heading_' + index"
                      class="w-full"
                      :disabled="!isEditable"
                    />
                    <span class="text-danger text-sm" v-show="errors.has(`faq_heading_${index}`)">{{ errors.first(`faq_heading_${index}`) }}</span>
                  </div>
                  <div class="px-2">
                    <vs-textarea
                      rows="5"
                      cols="5"
                      icon-pack="feather"
                      type="text"
                      v-validate="'required|exclude_special_char'"
                      data-vv-as="FAQ Description "
                      v-model="faqValue.answer"
                      label="FAQ Description *"
                      min="1"
                      placeholder="USEFUL CONTACT DETAILS: Khalsa Aid India Office: +91 175-5001300 Khalsa Aid UK WHATSAPP: +44 7487 270969 Khalsa Aid UK Office: 0044 1753567457 Khalsa Aid India Email: office.India@khalsaaid.org Khalsa Aid General Email: info@Khalsaaid.org Khalsa Aid Canada: office.Canada@Khalsaaid.org"
                      :name="'faq_description_' + index"
                      class="w-full mb-0"
                      :disabled="!isEditable"
                    />
                    <span class="text-danger text-sm" v-show="errors.has(`faq_description_${index}`)">{{ errors.first(`faq_description_${index}`) }}</span>
                  </div>
                </div>
                <div class="" v-if="isEditable">
                  <vx-tooltip :text="`Remove FAQ`">
                    <vs-button @click="removeData('details', index)" color="danger" type="gradient" icon-pack="feather" icon="icon-trash-2" />
                  </vx-tooltip>
                </div>
              </div>

              <vs-divider></vs-divider>
            </div>
          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="">
        <div class="vx-col w-full">
          <div class="flex flex-wrap justify-between">
            <div>
              <vs-button class="mr-2 vs-con-loading__container" id="update-faq" @click="save_changes" v-if="isEditable">Save Changes</vs-button>
              <vs-button color="danger" class="text-white-500" @click="navigateList">Cancel</vs-button>
            </div>
          </div>
          <vs-divider></vs-divider>
          <div v-if="isEditable">
            <vs-button color="warning" @click="addData('details')" class="" size="default"> Add New FAQ</vs-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  /** Page Name */
  name: 'AddUpdate',

  /** data */
  data() {
    return {
      form: {
        label: null,
        details: [],
        module: 'Organization',
        organization: this.$route.params.id
      }
    }
  },

  /** Props */
  props: {
    selectedRecordId: String,
    module_name: String,
    action_name: String,
    showModal: Boolean
  },

  /** computed */
  computed: {
    ...mapState('organization', ['createLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    validateForm() {
      return !this.errors.any()
    },
    isEditable() {
      return this.checkPermissionSlug('faq_edit')
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  /** created */
  async created() {
    if (this.selectedRecordId) {
      await this.$store.dispatch('organization/faqShow', this.selectedRecordId).then(async (res) => {
        const data = res.data.data
        /* form variable */
        this.form.label = data.label
        this.form.details = data.details
      })
    }
  },

  /** methods */
  methods: {
    ...mapActions('organization', {
      create: 'faqCreate',
      update: 'faqUpdate'
    }),
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.isActive = false
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        if (this.selectedRecordId) {
          response = await this.update({
            id: this.selectedRecordId,
            data: this.form
          })
        } else {
          response = await this.create(this.form)
        }
        this.isActive = false
        // this.$router.push(`/gurudwara/${this.form.gurudwara}/faq-list`)
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** add data in array */
    addData(type) {
      switch (type) {
      case 'details':
        this.form.details.push({
          question: '',
          answer: ''
        })
        break
      default:
        break
      }
    },

    /** remove data from array */
    removeData(type, index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          switch (type) {
          case 'details':
            this.form.details.splice(index, 1)
            break
          default:
            break
          }
        },
        acceptText: 'Delete'
      })
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#update-faq',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#update-faq > .con-vs-loading')
      }
    }
  }
}
</script>
